var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ICountUp',{attrs:{"startVal":_vm.startVal,"endVal":_vm.endVal,"options":_vm.options},on:{"ready":_vm.onReady}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }